const protocol = 'https://';
const host = 'ms.spx.dotnet.vecto.it/';

const API_URL = protocol + host;

export default API_URL;